import { useCallback, useEffect, useState } from 'react';
import { attendanceService } from '../../services/attendance';

export const useLiveAttendance = (filters) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const data = await attendanceService.getLiveAttendance(filters);
      setRows(data);
    } catch (err) {
      setError(attendanceService.mapErrorMessage(err, 'Failed to load live attendance'));
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { rows, loading, error, refresh };
};
